import { Button } from "@headlessui/react";
import useModal from "../../../../hooks/useModal";
import ViewParamField from "./ViewParamField";
import { FilePenLine } from "lucide-react";

export default function RWADataRow({ title, field, param, bordered = true }) {
  const { open } = useModal("rwa-edit-param-modal")
  const { open: openPage } = useModal("rwa-edit-param-page-modal");
  
  return (
    <div className="flex items-start gap-2">
      <div className="flex-1">
        <div className="flex items-center gap-2 py-2">
          <p className="text-gray-500 ">{title || field?.label}</p>
          <div>
            <Button
              type="tertiary"
              className=" cursor-pointer p-1 bg-gray-200 hover:bg-gray-300 !rounded-full"
              onClick={() => {
                  openPage(param);
              }}
            >
              <FilePenLine className="w-4 h-4" />
            </Button>
          </div>
        </div>
        {bordered ? <div className="border border-gray-300 rounded-md p-4 min-h-[8rem]">
          <ViewParamField
            fieldType={field?.fieldType}
            value={field?.value}
            placeholder={`Add ${title || field?.label}`}
            onClick={() => {console.log("field", param); open(param)}}
          />
        </div> : <ViewParamField
          fieldType={field?.fieldType}
          value={field?.value}
          placeholder={`Add ${title || field?.label}`}
          onClick={() => {console.log("field", param); open(param)}}
        />}
        
      </div>
    </div>
  )
}